function showSuccessMessage() {
    alert('Registration was successful! You will be redirected to the home page in 2 seconds.');
}